exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".box__1p7 {\n  padding: 40px 40px 20px;\n  flex-direction: column; }\n  .box__1p7 p {\n    margin-bottom: 14px; }\n    .box__1p7 p:last-of-type {\n      margin-bottom: 0; }\n  .box__1p7 ol, .box__1p7 ul {\n    padding: 20px 20px 10px 30px; }\n  .box__1p7 li {\n    list-style-type: decimal;\n    margin-bottom: 10px; }\n", ""]);
// Exports
exports.locals = {
	"box": "box__1p7"
};